// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"tag__visuallyhidden--OXHF9","focusable":"tag__focusable--BfEoG","tag":"tag__tag--wVNVp"};